// @flow
import * as React from "react"
import { connect } from "react-redux"
import CookiesConsent from "@kiwicom/nitro/lib/components/CookiesConsent"

import { getMovedTop } from "common/utils/scrollUtils"
import { setCookiesHeight as _setCookiesHeight } from "./services/actions"

type Props = {
  isMobile: boolean,
  page: string,
  isSimpleLandingPage: boolean,
  setAccepted: () => void,
  isSearch: string => boolean,
  setCookiesHeight: number => void,
}

type State = {
  isShown: boolean,
}

class CookiesScroller extends React.Component<Props, State> {
  state = {
    isShown: true,
  }

  componentDidMount() {
    const { page, isSimpleLandingPage } = this.props
    const obj = this.objectForListener(page, isSimpleLandingPage)
    if (obj) obj.addEventListener("scroll", this.handleScroll)
    window.addEventListener("resize", this.handleResize)
  }

  componentDidUpdate(prevProps: Props) {
    const { page, isSimpleLandingPage, isSearch } = this.props

    if (
      isSearch(prevProps.page) !== isSearch(page) ||
      isSimpleLandingPage !== prevProps.isSimpleLandingPage
    ) {
      const obj = this.objectForListener(prevProps.page, prevProps.isSimpleLandingPage)
      if (obj) obj.removeEventListener("scroll", this.handleScroll)

      const newObj = this.objectForListener(page, isSimpleLandingPage)
      if (newObj) newObj.addEventListener("scroll", this.handleScroll)
    }
  }

  componentWillUnmount() {
    const { page, isSimpleLandingPage } = this.props
    const obj = this.objectForListener(page, isSimpleLandingPage)
    if (obj) obj.removeEventListener("scroll", this.handleScroll)
    window.addEventListener("resize", this.handleResize)
  }

  handleResize = () => {
    if (this.node) {
      const size = this.node.getBoundingClientRect()
      if (size.height > 0) {
        this.props.setCookiesHeight(size.height)
      }
    }
  }

  node: ?HTMLDivElement

  handleScroll = () => {
    const { page, isMobile, isSearch } = this.props

    if (!isMobile) {
      const el = isSearch(page)
        ? document.querySelector(".SearchView") // $FlowFixMe
        : document.scrollingElement

      // top position of the element on the page
      const elementPosition = el ? el.scrollTop : 0
      const scrolledTop = getMovedTop() || 0

      // show element when it's less than 100px from the top
      const isShown = elementPosition < 100 && scrolledTop < 100
      this.setState({ isShown })
    }
  }

  refCallback = (element: ?HTMLDivElement) => {
    if (element) {
      const size = element.getBoundingClientRect()
      if (size.height > 0) {
        this.props.setCookiesHeight(size.height)
      }
      this.node = element
    }
  }

  objectForListener(page: string, isRootPage: boolean) {
    const { isSearch } = this.props
    return isSearch(page) && !isRootPage ? document.querySelector(".SearchView") : window
  }

  render = () => {
    const { setAccepted } = this.props
    const { isShown } = this.state

    return isShown && <CookiesConsent onAccept={setAccepted} />
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  null,
  dispatch => ({
    setCookiesHeight: height => dispatch(_setCookiesHeight(height)),
  }),
)(CookiesScroller)
